import {
  Box,
  constants,
  Grid,
  Skeleton,
  Stack,
} from '@redbubble/design-system';

import styles from './SimilarDesignsSkeleton.module.scss';

export const SimilarDesignsSkeleton: React.FC = () => {
  const limit = 8;

  return (
    <Box className={styles.grid} data-testid="similar-designs-skeleton">
      <Grid columns={2}>
        {Array.from({ length: limit })
          .fill('')
          .map((_, i) => {
            return (
              <Box
                // biome-ignore lint/suspicious/noArrayIndexKey: noArrayIndexKey
                key={i}
                style={{
                  opacity: 1 - (i + (i % 2 ? 0 : 1) - 1) / limit,
                }}
              >
                <Stack spacing="s">
                  <Skeleton
                    ratio={constants.RATIO_SQUARE}
                    animated
                    roundedCorners
                  />

                  <Skeleton
                    height={8 * 2}
                    width={8 * 7 + 8 * (8 * Math.random())}
                    animated
                    roundedCorners
                  />

                  <Skeleton
                    height={8 * 3}
                    width={8 * 8 + 8 * (8 * Math.random())}
                    animated
                    roundedCorners
                  />
                </Stack>
              </Box>
            );
          })}
      </Grid>
    </Box>
  );
};
